import { connect } from "react-redux";
import MenuBox from "../components/MenuBox/MenuBox";
import BeatLoader from "react-spinners/BeatLoader";
import { useState, useEffect, useCallback } from "react";

function Home({ user }) {
  const [loading, setLoading] = useState(true);
  const [menuReady, setMenuReady] = useState(false);

  useEffect(() => {
    let mounted = true;

    if (user) {
      // Precarica i font e le immagini
      Promise.all([
        document.fonts.ready,
        // Aspetta che il menu sia caricato
        new Promise<void>(resolve => {
          if (menuReady) resolve();
          // Se il menu è già pronto, risolvi immediatamente
        })
      ]).then(() => {
        // Assicurati che il componente sia ancora montato
        if (mounted) {
          // Aggiungi un piccolo delay per una transizione più fluida
          setTimeout(() => {
            setLoading(false);
          }, 100);
        }
      });
    }

    return () => {
      mounted = false;
    };
  }, [user, menuReady]);

  const handleMenuReady = useCallback(() => {
    setMenuReady(true);
  }, []);

  return (
    <div className="container mx-auto px-0 sm:px-12 columns-3xl lg:columns-auto">
      {/* Contenuto sempre presente ma inizialmente nascosto */}
      <div className={`transition-opacity duration-300 ${loading ? 'opacity-0' : 'opacity-100'}`}>
        <div className="text-center hidden sm:block">
          <h1 className="text-3xl mb-16">
            Bentornato, <span className="text-blue-500">{user?.firstName} {user?.lastName}</span>
          </h1>
        </div>
        <div>
          <MenuBox onReady={handleMenuReady} />
        </div>
      </div>

      {/* Loader */}
      {loading && (
        <div className="fixed inset-0 flex justify-center items-center bg-white z-50">
          <BeatLoader color="#2563eb" />
        </div>
      )}
    </div>
  );
}

const mapStateToProps = ({ authUser }) => {
  const { user } = authUser;
  return { user };
};

export default connect(mapStateToProps, {})(Home);